import type React from "react";
import { FullScreen } from "react-full-screen";

import { useVenueSettings } from "@workspace/venue-management";

import { KioskContext } from "./kiosk-context";
import { useKioskOverview } from "./use-kiosk-overview";

export function KioskContextProvider({ children }: React.PropsWithChildren) {
	const opts = useVenueSettings();
	const context = useKioskOverview(opts);

	return (
		<KioskContext
			value={{
				...context,
			}}
		>
			<FullScreen handle={context.handle}>
				<>{children}</>
			</FullScreen>
		</KioskContext>
	);
}
